<!--
 * @Descripttion: 
 * @Date: 2021-06-04 17:32:37
 * @LastEditors: Sima thief
 * @LastEditTime: 2021-06-11 16:42:56
 * @Author: Sima thief
-->
<template>
  <div class="page">
    <div>
      <el-button type="primary" @click="handlerAdd">新增</el-button>
    </div>

    <el-table
      ref="multipleTable"
      :data="mainOrders"
      tooltip-effect="dark"
      style="width: 100% , margin-top: 20px"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        prop="dealdata"
        label="轨迹发生时间"
        width="200"
      ></el-table-column>
      <el-table-column prop="locationc" label="地点"> </el-table-column>
      <el-table-column prop="locatione" label="地点(英)"> </el-table-column>
      <el-table-column prop="statusc" label="状态"> </el-table-column>
      <el-table-column prop="statuse" label="状态(英)"> </el-table-column>
      <el-table-column prop="remarks" label="备注"> </el-table-column>
      <el-table-column prop="inputer" label="录入人"> </el-table-column>
      <el-table-column prop="inputtime" label="录入时间" width="200">
      </el-table-column>
      <!-- <el-table-column prop="address" label="修改人">
      </el-table-column>
      <el-table-column prop="address" label="修改时间" >
      </el-table-column> -->
      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button
            @click.native.prevent="deleteRow(scope.$index, mainOrders)"
            type="text"
            size="small"
          >
            移除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- <div class="block mr-top-20 flex-container justify-content-end">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage4"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="100"
        layout="total, sizes, prev, pager, next, jumper"
        :total="400"
      >
      </el-pagination>
    </div> -->
    <el-dialog :visible.sync="dialogTableVisible" :modal="false">
      <el-form
        :model="trajectory"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
      
      >
        <el-form-item label="状态" prop="tempId">
          <el-select v-model="trajectory.tempId" placeholder="" @change="handlerChange">
            <el-option
              v-for="item in lists"
              :key="item.id"
              :label="item.statusc"
              :value="item.id"
            ></el-option>
            <!-- <el-option label="区域二" value="beijing"></el-option> -->
          </el-select>
        </el-form-item>
        <el-form-item label="时间" prop="dealdata">
          <el-input v-model="trajectory.dealdata"></el-input>
        </el-form-item>

         <el-form-item label="地点" prop="locationc">
          <el-input v-model="trajectory.locationc"></el-input>
        </el-form-item>
        <el-form-item label="状态(英)" prop="statuse">
          <el-input v-model="trajectory.statuse"></el-input>
        </el-form-item>
         <el-form-item label="地点(英)" prop="locatione">
          <el-input v-model="trajectory.locatione"></el-input>
        </el-form-item>
         <el-form-item label="备注" prop="remarks">
          <el-input v-model="trajectory.remarks"></el-input>
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')"
            >立即创建</el-button
          >
          <el-button @click="resetForm('ruleForm')">重置</el-button>
        </el-form-item> -->
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTableVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"
          >保存</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Trajectories",
  props: {
    mainOrders: {
      type: Array,
      default: function () {
        return [];
      },
    },
    jobId:{
      type: Number,
    }
  },
  data() {
    return {
      multipleSelection: [],
      dialogTableVisible: false,
      trajectory: {
        statusc: 0,
         tempId: 18955266200,
         dealdata: '',
       
        locationc: '',
        statuse: '',
        locatione: '',
        remarks:'',
        

       
        id: 0,
        inputer: '',
        inputtime: '',
        jobId: this.jobId,
       
      },
    
      rules: {
        tempId: [
          { required: true, message: "请选择状态", trigger: "change" },
        ],
        dealdata: [
          { required: true, message: "请输入时间", trigger: "blur" },
        ],
         locationc: [
          { required: true, message: "请输入地点", trigger: "blur" },
         
        ],
        statuse: [
          { required: true, message: "请输入状态(英)", trigger: "blur" },
         
        ],
         locatione: [
          { required: true, message: "请输入地点(英)", trigger: "blur" },
         
        ],
        
      },
      lists: [],
    };
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    deleteRow(index, rows) {
     
      rows.splice(index, 1);
      console.log('rows[index].id' , rows[index].id)
      this.deleteJobsTrackById(rows[index].id)
      
      
    },

    handlerAdd() {
      this.dialogTableVisible = true;
      this.getTrackTemp();
    },
    submitForm(formName) {
      const that = this
      this.$refs[formName].validate((valid) => {
       
        if (valid) {
          console.log(' that.trajectory' ,  that.trajectory)
          this.insertJobsTrackById()
        } else {
         
          return false;
        }
      });
    },

    getTrackTemp() {
      this.axios.post(`/carrier/track/getTrackTemp`).then((res) => {
        console.log("res", res);

        this.lists = res.data.datas;
      });
    },
    handlerChange(val){
      console.log('val' , val)
      for(let index in this.lists){
        if(this.lists[index].id === val){
          this.trajectory.statusc = his.lists[index].statusc
          break;
        }
      }
    },
    insertJobsTrackById(){
       this.axios.post(`/carrier/track/insertJobsTrackById` , this.trajectory).then((res) => {
        console.log('res' , res)
        if(res.data.code === 200){
          this.$message({
          showClose: true,
          message: '添加成功',
          type: 'success'
        });
        this.dialogTableVisible = false
        this.$emit('update')
        }else{
          
        }
          
       
      });
    },
    deleteJobsTrackById(id){
          this.axios.post(`/carrier/track/deleteJobsTrackById/${id}` ).then((res) => {
        
        if(res.data.code === 200){
          this.$message({
          showClose: true,
          message: '删除成功',
          type: 'success'
        });
          this.$emit('update')
        
        }else{
          
        }
          
        // console.log("res", res);

        // this.lists = res.data.datas;
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "../styles/index.scss";
.all {
  height: 80px;
  line-height: 80px;
  background-color: rgba(242, 242, 242, 1);
}
.flex-item {
  text-align: center;
}
.text {
  font-size: 16px;
}
.btn {
  width: 217px;
  height: 46px;
  line-height: 46px;
  text-align: center;
  border: rgba(215, 215, 215, 1) 1px solid;
  color: #5f4aff;
}
</style>


// WEBPACK FOOTER //
// src/components/mainOrders/components/Trajectories.vue